/* Zählt Leaf-Nodes in einer Baumstruktur (interne Hilfsfunktion)
 * @param {Object|Array} tree - Die Baumstruktur
 * @param {'all'|'checked'|'unchecked'} filter - Filteroption (Standard: 'all')
 * @returns {number} Anzahl der Leafs
 * @private
 */
function _countLeaves(tree, filter = 'all') {
  let count = 0;
  if (!tree) return count;

  const traverse = (node) => {
    if (Array.isArray(node)) {
      node.forEach(item => traverse(item));
      return;
    }
    if (node.children && Array.isArray(node.children) && node.children.length > 0) {
      node.children.forEach(child => traverse(child));
    } else {
      // Leaf node gefunden
      if (filter === 'all') {
        count++;
      } else if (filter === 'checked' && node.checked === true) {
        count++;
      } else if (filter === 'unchecked' && node.checked !== true) {
        count++;
      }
    }
  };

  traverse(tree);
  return count;
}

/* Zählt unchecked Leaf-Nodes in einer Baumstruktur
 * @param {Object|Array} tree - Die Baumstruktur
 * @returns {number} Anzahl der Leafs
 */
export function countUncheckedLeaves(tree) {
  return _countLeaves(tree, 'unchecked');
}

/* Zählt checked Leaf-Nodes in einer Baumstruktur
 * @param {Object|Array} tree - Die Baumstruktur
 * @returns {number} Anzahl der Leafs
 */
export function countCheckedLeaves(tree) {
  return _countLeaves(tree, 'checked');
}

/* Zählt alle Leaf-Nodes in einer Baumstruktur
 * @param {Object|Array} tree - Die Baumstruktur
 * @returns {number} Anzahl der Leafs
 */
export function countAllLeaves(tree) {
  return _countLeaves(tree, 'all');
}

/* Sammelt alle checked Leaf-Nodes als flache Liste
 * @param {Object|Array} tree - Die Baumstruktur
 * @returns {Array} Array mit allen gecheckte Leaf-Nodes
 */
export function gatherCheckedLeaves(tree) {
  const result = [];
  if (!tree) return result;

  const traverse = (node) => {
    if (Array.isArray(node)) {
      node.forEach(item => traverse(item));
      return;
    }
    if (node.children && Array.isArray(node.children) && node.children.length > 0) {
      node.children.forEach(child => traverse(child));
    } else {
      // Leaf node gefunden
      if (node.checked === true) {
        result.push(node);
      }
    }
  };

  traverse(tree);
  return result;
}

/* Sammelt alle eindeutigen IDs von checked Leaf-Nodes
 * @param {Object|Array} tree - Die Baumstruktur
 * @returns {Array} Array mit eindeutigen IDs
 */
export function gatherFilterIds(tree) {
  return [...new Set(gatherCheckedLeaves(tree).map(x => x.id))];
}
